class SubscriptionflowBuyNowButtonAdd extends HTMLElement {
    static get observedAttributes() {
        return ['bunowbutton'];
    }

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.intervalId = null;
        this.fullUrl = null;
    }

    connectedCallback() {
        console.log('🧩 <subscriptionflow-button-add> connected');
        this.startButtonPolling();
    }

    disconnectedCallback() {
        if (this.intervalId) clearInterval(this.intervalId);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'bunowbutton') {
            if (newValue && newValue !== 'null') {
                console.log('📦 Received SubscriptionFlow URL:', newValue);
                this.fullUrl = newValue;
                this.showCustomButton();
            } else {
                console.log('🔄 Subscription disabled or cleared');
                this.fullUrl = null;
                this.restoreWixButton();
            }
        }
    }

    startButtonPolling() {
        this.intervalId = setInterval(() => {
            const checkoutBtn = document.querySelector('[aria-label="Buy Now"]');
            if (checkoutBtn) {
                clearInterval(this.intervalId);
                if (this.fullUrl) {
                    this.showCustomButton();
                }
            }
        }, 500);
    }

    showCustomButton() {
        const checkoutBtn = document.querySelector('[aria-label="Buy Now"]');
        if (!checkoutBtn || !this.fullUrl) return;

        // Hide original Buy Now button
        checkoutBtn.style.display = 'none';

        // Remove any existing custom button
        const existing = document.querySelector('#pbuy-now-link');
        if (existing) existing.remove();

        // Create new "Subscribe Now" button
        const link = document.createElement('a');
        link.id = 'pbuy-now-link';
        link.textContent = 'Buy Now';
        link.href = this.fullUrl;
        link.target = '_blank';
        link.style.cssText = `
            display: flex;
            padding: 16px 20px;
            justify-content: center;
            background-color: rgb(32, 61, 43);
            color: white;
            border-radius: 100px;
            font-size: 16px;
            text-align: center;
            text-decoration: none;
            cursor: pointer;
        `;

        // Optional: postMessage to Wix parent
        link.addEventListener('click', () => {
            console.log('🟢 Subscribe Now clicked');
            window.parent.postMessage({ type: 'subscribeClicked', url: this.fullUrl }, '*');
        });

        // Insert after original button
        checkoutBtn.parentNode.insertBefore(link, checkoutBtn.nextSibling);
    }

    restoreWixButton() {
        const checkoutBtn = document.querySelector('[aria-label="Buy Now"]');
        const existing = document.querySelector('#pbuy-now-link');

        if (checkoutBtn) checkoutBtn.style.display = '';
        if (existing) existing.remove();
    }
}

customElements.define('subscriptionflow-product-buy-now', SubscriptionflowBuyNowButtonAdd);
